const EnumCasesSlugs = {
	PARADOX: 'custom-development-paradox-crm',
};

export default EnumCasesSlugs;
